import { useState, useRef } from "react";
import React, { useEffect } from "react";
import Cookies from 'universal-cookie';

// import { ClassicEditor, Essentials, Bold, Italic, Font, Paragraph } from 'ckeditor5';
// import 'ckeditor5/ckeditor5.css';
import "./CkEditorStyle/bbb.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import { useOutletContext } from "react-router-dom";
// import { useQuill } from "react-quilljs";
import { axiosReq } from "../../commons/axiosReq";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import VideoUpload from "../../components/MainAdmin/MainComponents/VideoUpload";
import VideoLinkModal from "../../components/MainAdmin/Modals/VideoLinkModal";
import ImageUpload from "../../components/MainAdmin/MainComponents/ImageUpload";

const Video = Quill.import('formats/video');
const Link = Quill.import('formats/link');

class CoustomVideo extends Video {
    static create(value) {
        const node = super.create(value);

        const video = document.createElement('video')
        video.setAttribute('controls', true);
        video.setAttribute('type', "video/mp4");
        video.setAttribute('style', "height: 200px; width: 100%");
        video.setAttribute('src', this.sanitize(value));
        node.appendChild(video);

        return node;
    }

    // static sanitize(url) {
    //   return Link.sanitize(url);
    // }
};
CoustomVideo.blotName = 'video';
CoustomVideo.className = 'ql-video';
CoustomVideo.tagName = 'DIV';

Quill.register('formats/video', CoustomVideo);

const CustomToolbar = () => (
    <div id="toolbar">
        <select className="ql-header" defaultValue="" onChange={(e) => e.persist()}>
            <option value="1"></option>
            <option value="2"></option>
            <option value=""></option>
        </select>
        <button className="ql-bold"></button>
        <button className="ql-italic"></button>
        <button className="ql-underline"></button>
        <button className="ql-strike"></button>
        <button className="ql-blockquote"></button>
        <button className="ql-list" value="ordered"></button>
        <button className="ql-list" value="bullet"></button>
        <button className="ql-indent" value="-1"></button>
        <button className="ql-indent" value="+1"></button>
        <button className="ql-link"></button>
        <button className="ql-image"></button>
        <button className="ql-video"></button>
        <button className="ql-clean"></button>
    </div>
);
const MainAdminUploadNewsRelease = () => {

    const [ck, setCk] = useState(false);
    const [setText, text, accept, data, video, setVideo, image, setImage] = useOutletContext();
    const [showAddModal, setShowAddModal] = useState(false);

    const [token, setToken] = useState();
    //   const [videos, setVideos] = useState();
    const [newImage, setNewImage] = useState();

    useEffect(() => {
        const cookies = new Cookies();
        setToken(cookies.get('token'));
    }, []);
    //     var waitCKEDITOR = setInterval(function() {

    //         clearInterval(waitCKEDITOR);
    //         if(!ck) {
    //             setCk(true)
    //         ClassicEditor
    //         .create( document.querySelector( '#editor' ), {

    //          language: {
    //              // The UI will be English.
    //              ui: 'fa',
    //              // But the content will be edited in Arabic.
    //              content: 'fa'
    //          },
    //             plugins: [ Essentials, Bold, Italic, Font, Paragraph ],
    //             toolbar: {
    //                 items: [
    //                     'undo', 'redo', '|', 'bold', 'italic', '|',
    //                     'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor'
    //                 ]
    //             }
    //         } )


    //         .then( 
    //             setCk(true)
    //     )
    //         .catch( /* ... */) }

    //  }, 100/*milli*/);





    const [editorContent, setEditorContent] = useState('');

    const handleEditorChange = (content) => {
        console.log(text)
        setText(content);
        console.log(content)
        // content.insertEmbed(0, 'video', 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4', 'user'); 
    };
    const handleVideo = () => {
        const url = prompt('Enter video URL:');
        if (url) {
            const range = quillRef.current.getEditor().getSelection();
            // quillRef.current.getEditor().clipboard.dangerouslyPasteHTML(range.index, `<iframe src="${url}" frameborder="0" allowfullscreen></iframe>`);
            quillRef.current.getEditor().clipboard.dangerouslyPasteHTML(0, `<iframe src="${url}" frameborder="0" allowfullscreen></iframe>`);
        }
    };
    const Font = ReactQuill.Quill.import('formats/font'); // <<<< ReactQuill exports it
    Font.whitelist = ['IRANYekanNormal']; // allow ONLY these fonts and the default
    ReactQuill.Quill.register(Font, true);
    const quillRef = useRef(null);

    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block', { 'header': 1 }, { 'header': 2 }],
        ['link', 'image', 'video', 'formula'],

        // custom button values
        ['clean', { 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub' }, { 'script': 'super' }, { 'color': [] }, { 'background': [] }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }, { 'direction': 'rtl' }, { 'align': [] }],          // outdent/indent
        // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        // dropdown with defaults from theme
        [{ 'font': Font.whitelist }],


        // remove formatting button
    ];

    const modules = {
        toolbar: {
            container: "#toolbar",
            // container: toolbarOptions,
            handlers: {
                video: handleVideo,
            },
        },
    };

    useEffect(() => {
        handleVideorChange()
    }, [video]);
    const handleVideorChange = () => {
        if (video?.length > 0) {
            console.log("change")
            console.log(111)
            console.log(text?.substring(0, text.length - 4))
            console.log(text + video)
            setText(text?.substring(0, text.length - 4) + '<p>video</p></p>')
        }
    }
    useEffect(() => {
        handleImageChange()
    }, [newImage]);
    const handleImageChange = () => {
        console.log(0)
        console.log(newImage)
        console.log(image)
        if (newImage?.length > 0) {
            console.log("change")
            console.log(111)
            console.log(text?.substring(0, text.length - 4))
            setImage([...image, newImage])
            setText(text?.substring(0, text.length - 4) + '<p>image</p></p>')
        }
    }
    return (


        <div className="border-borderGray border-2 rounded-[15px]">
            <div className="flex items-center border-b-2 border-borderGray p-[15px] justify-between pr-3">
                <div className="flex items-center">
                    <p className="font-IRANYekanExtra text-[15px] text-mainColor2">متن خبر</p>

                    <p className="text-[#ff0000]">*</p>
                </div>
                <div className="ml-3 flex  ">
                    <button onClick={() => setShowAddModal(true)} className="w-[150px] mx-3 h-[50px] bg-Orange2  
                        shadow-norm-shadow rounded-[15px] flex justify-center items-center " >
                        <p className="font-IRANYekanBold text-[18px] text-white"> ویدیو با لینک</p>
                    </button>
                    {
                        token ?
                            <VideoUpload text={text} setText={setVideo} token={token} />
                            : null}
                </div>
                <div className="ml-3 flex  ">

                    {
                        token ?
                            <ImageUpload text={text} setText={setNewImage} image={newImage} token={token} />
                            : null}
                </div>

            </div>
            <div>
                <div>

                    <CustomToolbar />

                    <ReactQuill
                        value={text}
                        // ref={quillRef}

                        onChange={handleEditorChange}
                        modules={{
                            toolbar: toolbarOptions,
                            // handlers: {
                            //     video: handleVideo,
                            // },
                        }
                        }
                        // modules={modules}

                        formats={[
                            'header', 'font', 'size',
                            'bold', 'italic', 'underline', 'strike', 'blockquote',
                            'list', 'bullet', 'indent',
                            'link', 'image', 'align'
                        ]}
                        // ref={quillRef}
                        placeholder="متن را اینجا بنویسید"
                        style={{ direction: 'rtl', textAlign: 'right' }}
                    />

                </div>
                <div className="p-[30px] flex justify-between">


                </div>

            </div>
            {showAddModal ? <VideoLinkModal title={'افزودن لینک جدید'} buttonName={'ثبت'} setShowModal={setShowAddModal} setVideo={setVideo} /> : null}

        </div>

    )
}

export default MainAdminUploadNewsRelease;